import React, { useEffect, useRef, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import styled from 'styled-components';
import MoneyIcon from '@material-ui/icons/Money';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import BoxHeaderIcon from '../../../../../../../../components/Layout/Components/Box/Header/BoxHeaderIcon';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import makeStyles from '@material-ui/core/styles/makeStyles';
import BoxHeader from '../../../../../../../../components/Layout/Components/Box/Header/BoxHeader';
import { useDispatch, useSelector } from 'react-redux';
import { getPrintDataAction, postTransactionAction } from '../../../actions';
import Alert from '@material-ui/lab/Alert';
import { ERROR, LOADING, SUCCESS } from '../../../../../../../../enums/states';
import PaymentButton from './components/PaymentButton';
import NumPad from './components/NumPad';
import Error from '../../../../../../../../components/Error';


const ButtonsRow = styled.div`
  display: flex;
  padding: 20px;
`;

const useStyles = makeStyles(() => ({ root: { overflow: 'visible', minHeight: '580px' } }));

const PaymentDialog = ({ open, handleClose, total, transactionId }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const posting = useSelector((state) => state?.receipt?.header?.metadata?.posting);
  const [paid, setPaid] = useState(0);
  const [pressedPaymentButton, setPressedPaymentButton] = useState(null);
  const postingRef = useRef(false);

  useEffect(() => {
    if (posting?.status !== LOADING) {
      setPressedPaymentButton(null);
      postingRef.current = false;
    }
    if (posting?.status === SUCCESS) {
      dispatch(getPrintDataAction(transactionId));
      handleClose();
    }
  }, [posting?.status, handleClose, dispatch, transactionId]);

  const paymentButtonClick = (type) => {
    // Pojistka proti dvojkliku / druhé platbě: ignoruj další klik, dokud
    // odeslání běží. Ref je synchronní – zachytí i velmi rychlý dvojklik
    // (i na druhý typ platby), než se stihne překreslit disabled stav.
    if (postingRef.current || pressedPaymentButton !== null || posting?.status === LOADING) {
      return;
    }
    postingRef.current = true;
    setPressedPaymentButton(type);
    dispatch(postTransactionAction(transactionId, type, total));
  };

  const paymentButtons = [
    {
      type: 1,
      value: (
        <>
          <MoneyIcon style={{ fontSize: '5em' }} />
          <FormattedMessage id={'payment.cash'} />
        </>
      ),
      color: '#43a047',
    },
    {
      type: 2,
      value: (
        <>
          <CreditCardIcon style={{ fontSize: '5em' }} />
          <FormattedMessage id={'payment.card'} />
        </>
      ),
      color: '#e53935',
    },
  ];

  const calcButtonPressed = (value) => {
    setPaid((old) => {
      let string = old.toString();
      switch (value) {
        case 'X':
          return 0;
        case '<':
          return parseFloat(string.substr(0, string.length - 1) || 0);
        default:
          return parseFloat(string + value);
      }
    });
  };

  return (
    <Dialog
      disableBackdropClick={posting?.status === LOADING}
      disableEscapeKeyDown={posting?.status === LOADING}
      open={open}
      onClose={handleClose}
      onExited={() => {
        setPaid(0);
      }}
      classes={{ paperScrollPaper: classes.root }}>
      <BoxHeader>
        <BoxHeaderIcon color={'#fb8c00'}>
          <div style={{ width: '30px', height: '30px', textAlign: 'center' }}>
            <AccountBalanceWalletIcon style={{ fontSize: '1.5em' }} />
          </div>
        </BoxHeaderIcon>
        <div style={{ padding: '0px', margin: '0px' }}>
          <h2 style={{ paddingTop: '10px', margin: '0px' }}>
            <FormattedMessage id={'payment.title'} /> - <FormattedNumber value={total || 0} currency={'CZK'} {...{style: 'currency'}} />
          </h2>
        </div>
      </BoxHeader>
      <ButtonsRow>
        {paymentButtons.map((button, index) => (
          <PaymentButton
            loading={pressedPaymentButton === button.type}
            key={index}
            color={button.color}
            onClick={() => {
              paymentButtonClick(button.type);
            }}
            disabled={posting?.status === LOADING ? true : false}>
            {button.value}
          </PaymentButton>
        ))}
      </ButtonsRow>
      {posting?.status === ERROR && (
        <Alert variant="filled" severity="error" style={{ margin: '10px' }}>
          <Error errorCode={posting?.error?.error} />
        </Alert>
      )}
      <NumPad total={total} paid={paid} calcButtonPressed={calcButtonPressed} />
    </Dialog>
  );
};

export default PaymentDialog;
